import Unipage from "../templates/Unipage";

export default function Reflection() {

    return (<Unipage
        content={
            <>
                <h2>Gallery Walk Reflection</h2>
                <p>On a blank sheet of paper, create an eye-catching advertisment for your Grand Design. For example:</p>
                <p><img src="/arduino_imgs/amazing_lie_detector.png" height="400 px" /></p>

                <h3>Reflection Question</h3>
                <p>
                    On a separate sheet of paper, answer the following reflection questions.
                    Staple the reflection questions to the back of the advertisment.
                    <ol>
                        <li>How does your grand design work?</li>
                        <li>How does your grand design provide a benefit for people or society?</li>
                        <li>What did you learn?</li>
                        <li>What challenges did you face? Were they expected? A surprise?</li>
                        <li>What are some successes you had?</li>
                        <li>How can you apply what you learned about project managemnt to your future endeavors?</li>
                    </ol>
                </p>
            </>
        }
    />);

}